import { api } from '../client';
import type { Event, Position, ReportStop, ReportSummary, ReportTrip } from '../types';

interface BaseParams {
  deviceId?: number | number[];
  groupId?: number | number[];
  /** ISO 8601 */
  from: string;
  /** ISO 8601 */
  to: string;
}

interface EventsParams extends BaseParams {
  type?: string | string[];
}

export const reportsApi = {
  route: (params: BaseParams) => api.get<Position[]>('/reports/route', { query: params }),
  events: (params: EventsParams) => api.get<Event[]>('/reports/events', { query: params }),
  summary: (params: BaseParams) => api.get<ReportSummary[]>('/reports/summary', { query: params }),
  trips: (params: BaseParams) => api.get<ReportTrip[]>('/reports/trips', { query: params }),
  stops: (params: BaseParams) => api.get<ReportStop[]>('/reports/stops', { query: params }),
};
